module.exports = (__webpack_require__(2))(8);


//////////////////
// WEBPACK FOOTER
// delegated ./src/events.js from dll-reference girder_plugin_slicer_cli_web
// module id = 10
// module chunks = 0